import type { FlagConfigs } from '@square/feature-relay-web-sdk'
import { createBooleanFlag, createJSONFlag } from '@square/feature-relay-web-sdk'

export interface DatadogConfig {
  sessionSampleRateOverride: number
}

export const flags: FlagConfigs = {
  rumFeatureFlagEnabled: createBooleanFlag({
    key: 'cash-web-help-center-datadog-rum-enabled',
    defaultValue: false,
  }),
  datadogConfig: createJSONFlag<DatadogConfig>({
    key: 'cash-web-help-center-datadog-rum-config-new',
    defaultValue: {
      sessionSampleRateOverride: 0,
    },
  }),
}
